import {
  ListItem,
  HStack,
  List,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  VStack,
} from '@chakra-ui/react';
import Link from '../../Link';
import { NavPost } from '../../../types';

const MhySubMenuItem = ({
  url,
  title,
  children,
  isDeep,
  onNavigate,
}: NavPost & { isDeep?: boolean; onNavigate: () => void }) => (
  <ListItem mt="0 !important" {...(isDeep ? null : { _notLast: { mb: 2 } })}>
    <Link
      href={url}
      textStyle={`mainNav.${isDeep ? 'groupHeading' : 'linkItem'}`}
      onClick={onNavigate}
      mb={children ? 4 : 0}
      display="block"
    >
      {title}
    </Link>
    {children && (
      <List>
        {children.map((item) => (
          <MhySubMenuItem {...item} key={item.ID} onNavigate={onNavigate} />
        ))}
      </List>
    )}
  </ListItem>
);

const navDetailColor = 'highlightColor';

const getDropdownContentProps = {
  px: [4, 7],
  py: [4, 7],
  alignItems: 'flex-start',
  sx: {
    borderRadius: '0 0 6px 6px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)',
    position: 'relative',
    background: 'white',
    outline: 'none',
  },
  _before: {
    content: '""',
    height: '4px',
    background: navDetailColor,
    position: 'absolute',
    top: '-1px',
    left: '-1px',
    right: '-1px',
    bottom: '-8px',
  },
};

const DesktopMenuItem = ({
  title,
  children,
  onNavigate,
}: NavPost & { onNavigate: () => void }) => {
  const isDeep = children?.some(
    ({ children: grandChildren }) => !!grandChildren,
  );

  const Stack = isDeep ? HStack : VStack;

  return (
    <Popover placement="bottom-start" offset={[-30, 8]}>
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <Text
              as="button"
              type="button"
              textStyle="mainNav.navItem"
              pos="relative"
            >
              {title}
            </Text>
          </PopoverTrigger>
          <PopoverContent as="div" width="auto">
            <PopoverArrow bg={navDetailColor} />
            <Stack spacing="1rem" as={List} {...getDropdownContentProps}>
              {children?.map((item) => (
                <MhySubMenuItem
                  {...item}
                  key={item.ID}
                  onNavigate={() => {
                    onClose();
                    onNavigate();
                  }}
                  isDeep={isDeep}
                />
              ))}
            </Stack>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default DesktopMenuItem;
